module.exports = __webpack_public_path__ + "static/technologies-logo-32a3348535539936d717146f2d0bf48d.png";